/* eslint-disable */
import LegoToast from './legoToast.min.js';

export default {
    toast: new LegoToast({
        msg: "操作成功",
        time: 1200,
        extraclass: "extraclass"
    }),
    windowToast: function(msg) {
        console.log('windowToast', 'msg');
        this.toast.changeText(msg);
        this.toast.open();
    },
    /**海度上报 */
    hiidoReport: function(actType, hiidonum) {
        var page_type = 'tinyvideo';
        if(/sv_topic/.test(window.location.href)){
            page_type = 'topic';
        }else if(/shenquvideo/.test(window.location.href)){
            page_type = 'shenqu';
        }else if(/svmob/.test(window.location.href)){
            /** 子站的上报 */
            var hevent = new hiidoEvent('yylive','20017091');
            hevent.setActtype('104');
            hevent.setSys('5');
            hevent.reportJudge();
            return;
        }
        var hevent = new hiidoEvent('yylive', hiidonum || '20015389');
        hevent.setRef(document.referrer);
        hevent.setFrom(this.getURLParam('fromchannel') || '');
        hevent.setActtype(actType);
        hevent.setSys('5');
        hevent.setMoreinfo({
            "topic": "1",
            "page_type": page_type
        });
        hevent.reportJudge();
    },
    getURLParam: function(name, url) {
        var re = new RegExp("[\\?&#]" + name + "=([^&#]+)", "gi");
        var ma = (url || location.href).match(re);
        var strArr;
        if (ma && ma.length > 0) {
            strArr = (ma[ma.length - 1]);
            var _index = strArr.indexOf("=");
            return strArr.substring(_index + 1);
        }
        return '';
    },
}



// WEBPACK FOOTER //
// ./src/Footer/util/index.js